import React from "react";
import { Pie } from "react-chartjs-2";

const PieChart = ({ data, options }) => {
  return (
    <Pie
      data={data}
      options={{
        maintainAspectRatio: false,
        ...options,
      }}
    />
  );
};

export default PieChart;
